import React from 'react';

const NotFound: React.FC = () => {
    return <strong>404 Page not found!</strong>;
};

export default NotFound;
